<template>
	<div class="model-key">
		<!-- 搜索栏 -->
		<div class="search-bar">
			<div class="search-left">
				<el-input v-model="queryParams.keyName" placeholder="密钥名称" style="width: 200px; margin-right: 10px;"
					clearable></el-input>
				<el-select v-model="queryParams.modelTypeId" placeholder="模型类型"
					style="width: 200px; margin-right: 10px;" clearable>
					<el-option v-for="item in modelTypeList" :key="item.id" :label="item.typeName"
						:value="item.id"></el-option>
				</el-select>
				<el-button type="primary" icon="el-icon-search" @click="fetchData">搜索</el-button>
			</div>
			<el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增密钥</el-button>
		</div>

		<!-- 数据表格 -->
		<el-table :data="tableData" border style="width: 100%; margin-top: 20px;">
			<el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
			<el-table-column prop="platform" label="平台" width="120" align="center"></el-table-column>
			<el-table-column prop="keyName" label="密钥名称" width="120" align="center"></el-table-column>
			<el-table-column prop="keyRequestName" label="请求名" width="120" align="center"></el-table-column>
			<el-table-column prop="keyValue" label="密钥" width="200" show-overflow-tooltip align="center">
				<template slot-scope="scope">
					<span style="cursor: pointer;">{{ scope.row.keyValue}}</span>
				</template>
			</el-table-column>

			<el-table-column prop="userLevel" label="权益类型" width="120" align="center">
				<template slot-scope="scope">
					{{forLevelName(scope.row.userLevel,scope.row.modelTypeId)}}
				</template>
			</el-table-column>
			<el-table-column prop="expireTime" label="过期时间" width="180" align="center">
				<template slot-scope="scope">
					{{forTime(scope.row.expireTime)}}
				</template>
			</el-table-column>
			<el-table-column prop="status" label="状态" width="80" align="center">
				<template slot-scope="scope">
					<el-tag :type="scope.row.status === 0 ? 'success' : 'danger'">
						{{ scope.row.status === 0 ? '启用' : '禁用' }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<el-button size="mini" @click="handleEdit(scope.row)" v-if="scope.row.isView">编辑</el-button>
					<el-button size="mini" @click="tokeyFrom(scope.row)" v-if="scope.row.isView">更新密钥</el-button>
					<el-button size="mini" type="warning" @click="handleStatus(scope.row)" v-if="scope.row.isView">
						{{ scope.row.status === 0 ? '禁用' : '启用' }}
					</el-button>
					<el-button size="mini" v-if="scope.row.isView" type="danger" @click="handleDelete(scope.row)"
						:disabled="scope.row.status==0">删除</el-button>
					<el-button v-if="scope.row.shareOrg==0&&userType!=1" size="mini"
						@click="postModelKeySetShare(scope.row,1)">共享</el-button>
					<el-button v-if="scope.row.shareOrg==1&&userType!=1" size="mini"
						@click="postModelKeySetShare(scope.row,0)">取消共享</el-button>
					<el-button size="mini" v-if="(scope.row.modelTypeId==1||scope.row.modelTypeId==2)&&scope.row.isView"
						@click="getCozeBenefit(scope.row)">更新权益</el-button>
					<el-button size="mini"
						v-if="(scope.row.modelTypeId==1||scope.row.modelTypeId==2)&&scope.row.isView&&scope.row.userLevel"
						@click="workspaces(scope.row)">查询列表</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页 -->
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:current-page="queryParams.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="queryParams.pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total"
			style="margin-top: 20px; text-align: right;">
		</el-pagination>

		<!-- 新增/编辑弹窗 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
			<el-form :model="form" :rules="rules" ref="formRef" label-width="120px">
				<el-form-item label="模型类型" prop="modelTypeId">
					<el-select v-model="form.modelTypeId" placeholder="请选择模型类型" style="width: 100%;">
						<el-option v-for="item in modelTypeList.filter(v=>v.status==0&&v.isDeleted==0)" :key="item.id"
							:label="item.typeName" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="密钥名称" prop="keyName">
					<el-input v-model="form.keyName" placeholder="请输入密钥名称"></el-input>
				</el-form-item>
				<el-form-item label="密钥请求名" prop="keyRequestName">
					<el-input v-model="form.keyRequestName" placeholder="接口调用时的标识"></el-input>
				</el-form-item>
				<el-form-item label="密钥Key" prop="keyValue" v-if="!form.id">
					<el-input v-model="form.keyValue" type="textarea" :rows="1" @input="handleKeyChange"
						placeholder="请输入完整的密钥Key"></el-input>
				</el-form-item>
				<el-form-item label="过期时间" prop="expireTime">
					<el-date-picker v-model="form.expireTime" type="date" placeholder="选择过期时间" style="width: 100%;">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="状态" prop="status">
					<el-radio-group v-model="form.status">
						<el-radio :label="0">启用</el-radio>
						<el-radio :label="1">禁用</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="getCozeBenefit('',form.keyValue)"
					v-if="form.keyValue&&(form.modelTypeId==1||form.modelTypeId==2)&&!form.userLevel">检查密钥</el-button>
				<el-button type="primary"
					v-if="((form.modelTypeId==1||form.modelTypeId==2)&&form.userLevel)||(form.modelTypeId!=1&&form.modelTypeId!=2)"
					@click="handleSubmit">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="更新密钥" :visible.sync="iskeyForm" width="600px">
			<el-form :model="keyForm" label-width="120px">
				<el-form-item label="密钥名称" prop="keyName">
					{{keyForm.keyName}}
				</el-form-item>

				<el-form-item label="密钥Key">
					<el-input v-model="keyForm.keyValue" type="textarea" @input="handleKeyChange" :rows="3"
						placeholder="请输入完整的密钥Key"></el-input>
				</el-form-item>

				<el-form-item label="过期时间" prop="expireTime">
					<el-date-picker v-model="keyForm.expireTime" type="date" placeholder="选择过期时间" style="width: 100%;">
					</el-date-picker>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="iskeyForm = false">取 消</el-button>
				<el-button type="primary" @click="getCozeBenefit('',keyForm.keyValue)"
					v-if="keyForm.keyValue&&(keyForm.modelTypeId==1||keyForm.modelTypeId==2)&&!keyForm.userLevel">检查密钥</el-button>

				<el-button type="primary"
					v-if="((keyForm.modelTypeId==1||keyForm.modelTypeId==2)&&keyForm.userLevel)||(keyForm.modelTypeId!=1&&keyForm.modelTypeId!=2)"
					@click="putUpdateKeyOnly">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="智能体/工作流列表" :visible.sync="isWorkspaces" width="80%">
			<WorkspacesAiList :modeKeyId="modeKeyId" :workspacesList="workspacesList" @addBot="addBot"></WorkspacesAiList>
		</el-dialog>

	</div>
</template>

<script>
	import {
		permission
	} from "@/js/coze.js"
	import WorkspacesAiList from "./workspacesAiList"
	export default {
		name: 'ModelKey',
		components: {
			WorkspacesAiList,
		},
		data() {
			return {
				tableData: [],
				total: 0,
				modelTypeList: [],
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					keyName: '',
					modelTypeId: null
				},
				dialogVisible: false,
				dialogTitle: '',
				form: {
					id: null,
					platform: '',
					keyName: '',
					keyRequestName: '',
					keyValue: '',
					modelTypeId: null,
					expireTime: '',
					status: 0,
					providerCode: '',
					userLevel: '',
				},
				keyForm: {
					id: null,
					keyValue: '',
					expireTime: '',
					keyName: '',
					userLevel: '',
					modelTypeId: '',
				},
				iskeyForm: false,
				rules: {
					platform: [{
						required: true,
						message: '请输入平台',
						trigger: 'blur'
					}],
					keyName: [{
						required: true,
						message: '请输入密钥名称',
						trigger: 'blur'
					}],
					expireTime: [{
						required: true,
						message: '请输入过期时间',
						trigger: 'blur'
					}],
					keyValue: [{
						required: true,
						message: '请输入密钥Key',
						trigger: 'blur',
						// 🔥 核心：有 id 就不校验
						validator: (rule, value, callback) => {
							if (this.form.id) {
								callback(); // 有 id → 跳过
							} else if (!value) {
								callback(new Error('请输入密钥Key'));
							} else {
								callback();
							}
						}
					}],
					modelTypeId: [{
						required: true,
						message: '请选择模型类型',
						trigger: 'change'
					}],

				},
				userType: localStorage.getItem('userType'),
				userId: localStorage.getItem("userId"),
				permissionList: [], //扣子权益列表
				workspacesList: [],
				workspacesId: '',
				isWorkspaces:false,
				modeKeyId:'',//当前的密钥id
			}
		},
		created() {
			this.topermission()
		},
		methods: {
			addBot(val){
				this.isWorkspaces=false
				this.$emit('forActiveTab',val)
			},
			async workspaces(row) {
				this.workspacesList = []
				this.workspacesId = ''
				this.modeKeyId=''
				try {
					let res = await this.API.get(this.API.fileurl.getCozeWorkspaces, {
						"modelKeyId": row.id,
						"pageNum": 1,
						"pageSize": 50
					})
					if (res?.data?.code === 200) {
						var data = JSON.parse(res.data.data)
						if (data.code === 0) {
							if(data?.data?.workspaces){
								this.workspacesList =data.data.workspaces
								this.workspacesId =data.data.workspaces[0].id
								this.modeKeyId=row.id
								this.isWorkspaces=true
								console.log('this.workspacesList',this.workspacesList)
							}
						} else if (data.code == 4100) {
							if (data.msg == "authentication is invalid") {
								this.$message.error('密钥不存在或过期')
							}
						} else if (data.code == 4101) {
							alert('请开通"listWorkspace"权限')
						}
					}

				} catch (err) {

				} finally {

				}
			},
			handleKeyChange(val) {
				this.form.userLevel = ''
				this.keyForm.userLevel = ''
			},
			forLevelName(val, modelTypeId) {
				var name = ''
				if (val) {
					if (modelTypeId === 1 || modelTypeId === 2) {
						name = this.permissionList.find(v => v.value == val)?.label || ''
					}
				}
				return name
			},
			topermission() {
				this.permissionList = permission()
			},

			//查询
			async getCozeBenefit(val, keyValue) {
				var modelKeyId = val?.id || null
				try {
					let res = await this.API.get(this.API.fileurl.getCozeBenefit, {
						"modelKeyId": modelKeyId,
						"modelvalue": keyValue || null
					})
					if (res.data.code === 200) {
						var data = JSON.parse(res.data.data)
						if (data.code === 0) {

						} else if (data.code == 4100) {
							if (data.msg == "authentication is invalid") {
								this.$message.error('密钥不存在或过期')
							}
						} else if (data.code == 4101) {
							alert('请开通"getBenefit"权限')
						}
						if (!keyValue) {
							this.fetchData()
						} else {
							this.form.userLevel = data?.data?.basic_info?.user_level || ''
							this.keyForm.userLevel = data?.data?.basic_info?.user_level || ''

						}
					}

				} catch (err) {

				} finally {

				}

			},
			forTime(val) {
				if (!val) return ''
				return val.replace('T', " ")
			},

			// 获取模型类型
			async fetchModelTypeList() {
				try {
					const res = await this.API.get(this.API.admin.getModelTypeList, {
						pageNum: 1,
						pageSize: 100
					})
					let list = res.data.data.records || []
					// if(list.lenght>0){
					this.modelTypeList = list?.filter(v => v.authType == 0)
					// }
					// this.modelTypeList=[]
				} catch (e) {
					this.modelTypeList = []
				}
			},

			// 获取密钥列表
			async fetchData() {

				try {
					const res = await this.API.get(this.API.admin.getModelKeyList, this.queryParams)
					let list = res.data.data.records || [] //isView

					this.tableData = list.map(v => {
						v.isView = false
						// if(v.platformFlag==3){
						// 	v.platformFlag==5
						// }
						if (this.userType == v.platformFlag) {
							if (this.userId == v.userId) {
								v.isView = true
							}
						}
						return {
							...v
						}
					})
					this.total = res.data.data.total || 0
				} catch (e) {}
			},
			tokeyFrom(row) {
				// row.expireTime=row.expireTime.split('T')
				console.log('row.expireTime', row.expireTime)
				this.keyForm = {
					id: row.id,
					expireTime: row.expireTime,
					keyValue: '',
					keyName: row.keyName,
					userLevel: '',
					modelTypeId: row.modelTypeId
				}
				this.iskeyForm = true
			},
			putUpdateKeyOnly() {
				if (!this.keyForm.keyValue) return this.$message.success('请输入密钥')
				let expireTime = this.keyForm.expireTime
				if (expireTime != '') {
					const date = new Date(expireTime);
					// 设为当天 23:59:59
					date.setHours(23, 59, 59, 0);
					// 转成时间戳
					expireTime = this.formatDateTime(date)
				}

				this.API.put(this.API.admin.putUpdateKeyOnly, {
					id: this.keyForm.id,
					expireTime: expireTime,
					keyValue: this.keyForm.keyValue,
					userLevel: this.keyForm.userLevel,
				}).then(res => {
					this.$message.success('更新密钥成功')
					this.iskeyForm = false
					this.fetchData()
				}).catch(error => {
					this.$message.error('更新失败')
				})
			},
			// 新增
			handleAdd() {
				this.dialogTitle = '新增密钥'
				this.form = {
					id: null,
					platform: '',
					keyName: '',
					keyRequestName: '',
					keyValue: '',
					modelTypeId: null,
					expireTime: '',
					status: 0,
					providerCode: '',
					userLevel: '',
				}
				this.dialogVisible = true
			},
			postModelKeySetShare(row, value) {
				//设置共享
				let formData = new FormData();
				formData.append("id", row.id);
				formData.append("shareOrg", value);
				this.API.post(this.API.admin.postModelKeySetShare, formData).then(res => {
					this.fetchData()
					this.$message.success('修改共享成功')
				}).catch(error => {
					this.$message.error('修改共享失败')
				})
			},
			// 编辑
			handleEdit(row) {
				this.dialogTitle = '编辑密钥'
				this.form = {
					...row
				}
				this.dialogVisible = true
			},
			formatDateTime(date) {
				const y = date.getFullYear();
				const m = (date.getMonth() + 1).toString().padStart(2, '0');
				const d = date.getDate().toString().padStart(2, '0');
				const hh = date.getHours().toString().padStart(2, '0');
				const mm = date.getMinutes().toString().padStart(2, '0');
				const ss = date.getSeconds().toString().padStart(2, '0');


				return `${y}-${m}-${d}T${hh}:${mm}:${ss}`;
			},

			// 提交新增/修改
			async handleSubmit() {

				if (this.form.expireTime != '') {
					const date = new Date(this.form.expireTime);
					// 设为当天 23:59:59
					date.setHours(23, 59, 59, 0);
					// 转成时间戳
					this.form.expireTime = this.formatDateTime(date)
				}
				let arr = this.modelTypeList.filter(v => v.id == this.form.modelTypeId)[0]
				this.form.providerCode = arr.typeCode
				this.form.platform = arr.typeName

				this.$refs.formRef.validate(async valid => {
					if (!valid) return this.$message('信息未填写完整')
					try {
						// 提交数据对象
						let submitData = {
							...this.form
						}
						if (this.form.id) {
							delete submitData.keyValue
						}
						// 执行提交
						if (this.form.id) {
							await this.API.put(this.API.admin.putModelKeyUpdate, submitData)
							this.$message.success('修改成功')
						} else {
							await this.API.post(this.API.admin.postModelKeyAdd, submitData)
							this.$message.success('新增成功')
						}

						this.dialogVisible = false
						this.fetchData()
					} catch (e) {}
				})
			},

			// 修改状态 启用/禁用
			async handleStatus(row) {
				const newStatus = row.status === 0 ? 1 : 0
				try {
					await this.API.put(this.API.admin.putModelKeyStatus + row.id + '?status=' + newStatus)
					this.fetchData()
					this.$message.success('状态已更新')
				} catch (e) {}
			},

			// 删除
			async handleDelete(row) {
				this.$confirm('确定删除？', '提示', {
					type: 'warning'
				}).then(async () => {
					try {
						await this.API.deleted(this.API.admin.deleteModelKeyRemove + row.id)
						this.$message.success('删除成功')
						this.fetchData()
					} catch (e) {}
				}).catch(() => {})
			},

			// 分页
			handleSizeChange(val) {
				this.queryParams.pageSize = val
				this.fetchData()
			},
			handleCurrentChange(val) {
				this.queryParams.pageNum = val
				this.fetchData()
			}
		},
		mounted() {
			this.fetchModelTypeList()
			this.fetchData()
		}
	}
</script>

<style scoped>
	.model-key {
		padding: 20px;
		background-color: #fff;
	}

	.search-bar {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.search-left {
		display: flex;
		align-items: center;
	}
</style>